module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"6\" height=\"10\" viewBox=\"0 0 6 10\" fill=\"#5d707d\"><path d=\"M5.621 2.46L3.325 4.983l2.296 2.523c.546.57.546 1.493 0 2.063-.546.57-1.431.57-1.977 0L.409 6.015a1.504 1.504 0 0 1 0-2.063L3.644.397a1.357 1.357 0 0 1 1.977 0c.546.57.546 1.493 0 2.063z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/arrow.svg
// module id = 855
// module chunks = 0